import {List, merge, mergeDeep, mergeWith} from 'immutable';

export const isLikeList = (a) => List.isList(a) || Array.isArray(a);

/**
 * Merge
 */
export const merger = merge;

/**
 * Deep merge
 */
export const recursiveMerger = mergeDeep;

/**
 * Deep merge while ignoring arrays
 *
 * @param a {*}
 * @param b {*}
 *
 * @returns {*}
 */
export const ignoreArrayMerger = function (a, b) {
    if (!isLikeList(a)) {
        if (typeof a === 'object' && !isLikeList(b) && typeof b === 'object')
            return mergeWith(ignoreArrayMerger, a, b);

        return b;
    }

    return a;
};

/**
 * Deep merge while replacing arrays
 *
 * @param a {*}
 * @param b {*}
 *
 * @returns {*}
 */
export const replaceArrayMerger = function (a, b) {
    if (!isLikeList(a) && typeof a === 'object' &&
        !isLikeList(b) && typeof b === 'object')
        return mergeWith(replaceArrayMerger, a, b);

    return b;
};